import { useEffect } from 'react';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { pathToRevInv } from '@pay-bill/services';

export const useRevInvBreadcrumbsEffect = (
  revInvoice:
    | {
        code: string;
        id: string;
      }
    | undefined
) => {
  useEffect(() => {
    if (!revInvoice) {
      return;
    }

    setBreadcrumbs([
      { name: 'Billing', path: '/works/supplier/billing' },
      {
        name: `Reverse Invoice ${revInvoice.code}`,
        path: pathToRevInv(revInvoice.id),
      },
    ]);
  }, [revInvoice]);
};
